export const getSerializedProductsComments = (comments) =>
  comments.map(({ user, ...comment }) => ({
    ...comment,
    author: user,
  }));
